<template>
  <div class="status-container" :style="styles[data.sintegraId]">
    {{ data.sintegrastatus }}
  </div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},

	data() {
		return {
			styles: [
				'background-color: #cd16241f; color: #cd1624;',
				'background-color: #26a96c1f; color: #26a96c;',
			],
		};
	},
};
</script>

<style scoped>
.status-container {
  display: flex;
  padding: 2.5px 5px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 600;
  /*    background-color: #ffa01c5d;  */
}
</style>
